import {
    HeadSectionContent,
    SectionsTitleText,
} from "../../models/common/common";
import colors from "../../styles/colors.module.scss";

const headTitle: SectionsTitleText[] = [
    {
        text: "Your bookings",
        color: colors.textPrimary,
        fontWeight: "fw-bold",
        newLine: true,
    },
];

const headSubTitle: SectionsTitleText[] = [
    {
        text: "",
        color: colors.textWhiteLight,
        fontWeight: "fw-bold",
        newLine: false,
    },
];

export const headData: HeadSectionContent = {
    backgroundImageUrl:
        "https://images.unsplash.com/photo-1633613286848-e6f43bbafb8d?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80",
    title: headTitle,
    subTitle: headSubTitle,
};

export const titleDeteleteBooking: SectionsTitleText[] = [
    {
        text: "Delete Booking?",
        color: colors.textPrimary,
        fontWeight: "fw-bold",
        newLine: false,
    },
];

export const subTitleDeteleteBooking: SectionsTitleText[] = [
    {
        text: "Write here your reason for request refund",
        color: colors.textGray,
        fontWeight: "",
        newLine: false,
    },
];

export const titleUploadAvatar: SectionsTitleText[] = [
    {
        text: "Upload Avatar image",
        color: colors.textPrimary,
        fontWeight: "fw-bold",
        newLine: false,
    },
];

export const subTitleUploadAvatar: SectionsTitleText[] = [
    {
        text: "Upload image for setting your avatar",
        color: colors.textGray,
        fontWeight: "",
        newLine: false,
    },
];
